(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ViewCaf', ViewCaf);

    ViewCaf.$inject = ['$resource'];

    function ViewCaf ($resource) {
        var resourceUrl =  'api/dashboardcafs/:department/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
